import type { RequestType } from "../../interfaces/Request";
import { requestTypeNavigateParser } from "../../interfaces/Request";

export function redirectToDocumentCreationScreen(
  documentType: RequestType,
  requestId: string,
) {
  return `/app/solicitudes/${requestId}/${requestTypeNavigateParser[documentType]}/crear`;
}
